import ApplicationError from './ApplicationError';
import { ApplicationErrorType } from './types';

/**
 * Wrapper component for the react-error-boundary package to return our error page.
 * To comply with the linter removed props as we dont need them right now.
 * props: FallbackProps
 */
export default function FallbackError() {
	return <ApplicationError type={ApplicationErrorType.Unavailable} />;
}
